import React from "react";
import styled from "styled-components/macro";
import { Link } from "react-router-dom";
import { ArrowRightAlt } from "@material-ui/icons";

export const LinkToPage = ({ location, text }) => {
  return (
    <>
      <PageLink to={location}>
        <h3>{text}</h3>
        <ArrowRightAlt className="icon-link" />
      </PageLink>
    </>
  );
};

const PageLink = styled(Link)`
  display: flex;
  margin-bottom: 40px;
  font-size: 22px;
  font-weight: bold;
  text-decoration: none;
  color: #d3420d;
  transition: all .3s ease;
  cursor: pointer;

  &:hover > .icon-link {
    transition: all .3s ease;
    transform: translateX(7px);
  }

  .icon-link {
    margin-top: 4px;
    font-size: 38px;
    transition: all .3s ease;
  }
`;
